(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-score/assets/javascripts/event-participant-outcome.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-score/assets/javascripts/event-participant-outcome.js');
"use strict";

const {
  useMemo,
  useState
} = React;
const {
  useSelector
} = ReactRedux;
const {
  useCouponContext
} = svs.components.tipsen.couponComponents;
const {
  makeSelectEventOutcomesFromBitmap
} = svs.components.tipsen.engine.selectors.couponSelectors;
const {
  Coupon
} = svs.components.tipsen.couponComponents;
const {
  useIsTipsinfoEnabled,
  getOutcomeLabels
} = svs.components.tipsen.hooks;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const {
  selectEngineOutcomes
} = svs.components.tipsen.engine.selectors.engineSelectors;
const {
  ReactButton
} = svs.ui;
const {
  MATCHEN
} = svs.utils.products.productIds;
const {
  getOutcomeAriaLabelScore
} = svs.components.poolBetting.ariaUtils;
const formatDistributionValue = value => value ? "".concat(value, "%") : '0%';
const EventParticipantOutcome = _ref => {
  let {
    distributions,
    eventNumber,
    outcomeGroupIndex,
    productId,
    sportType,
    teamName
  } = _ref;
  const {
    couponId
  } = useCouponContext();
  const selectOutcomes = useMemo(makeSelectEventOutcomesFromBitmap, []);
  const boardIndex = 0;
  const selections = useSelector(state => selectOutcomes(state, couponId, boardIndex, eventNumber, outcomeGroupIndex));
  const {
    isSvenskaFolketAsOutcomesEnabled
  } = useIsTipsinfoEnabled();
  const shouldPairDistributionWithOutcomes = !isSvenskaFolketAsOutcomesEnabled;
  const outcomeCount = useSelector(selectEngineOutcomes).outcomeCount;
  const outcomeHeatmap = useSelector(selectEngineOutcomes).outcomeHeatmap[sportType];
  const hasMoreOutcomes = outcomeHeatmap.minValue !== outcomeHeatmap.minStartValue || outcomeHeatmap.maxValue !== outcomeHeatmap.maxStartValue;
  const [showAllOutcomes, setShowAllOutcomes] = useState(false);
  const minValue = showAllOutcomes ? outcomeHeatmap.minValue : outcomeHeatmap.minStartValue;
  const maxValue = showAllOutcomes ? outcomeHeatmap.maxValue : outcomeHeatmap.maxStartValue;
  const outcomeLabels = getOutcomeLabels(minValue, maxValue, productId, teamName);
  const outcomes = useMemo(() => {
    const outcomesArray = outcomeLabels.map(outcome => ({
      ariaLabel: getOutcomeAriaLabelScore({
        svenskaFolketValue: isSvenskaFolketAsOutcomesEnabled ? formatDistributionValue(distributions === null || distributions === void 0 ? void 0 : distributions[outcome.sign]) : undefined,
        sign: outcome.sign,
        participantName: teamName
      }),
      sign: isSvenskaFolketAsOutcomesEnabled ? formatDistributionValue(distributions === null || distributions === void 0 ? void 0 : distributions[outcome.sign]) : outcome.text,
      isSelected: Boolean(selections[outcome.sign]),
      outcomeValue: outcome.sign
    }));
    return [...outcomesArray];
  }, [distributions, isSvenskaFolketAsOutcomesEnabled, outcomeLabels, selections, teamName]);
  return React.createElement(React.Fragment, null, React.createElement(Coupon.BetButtons, {
    boardIndex: boardIndex,
    className: "pg_coupon_row__event__participant__outcome__bet_buttons_grid",
    distributions: shouldPairDistributionWithOutcomes ? distributions : [],
    eventNumber: eventNumber,
    isClickable: true,
    outcomeCount: outcomeCount,
    outcomeGroupIndex: outcomeGroupIndex,
    outcomes: outcomes
  }), hasMoreOutcomes && React.createElement(ReactButton, {
    "aria-expanded": showAllOutcomes,
    "aria-label": showAllOutcomes ? 'Visa färre' : 'Visa fler',
    className: "pg_coupon_row__show_more_btn",
    onClick: () => setShowAllOutcomes(!showAllOutcomes)
  }, showAllOutcomes ? 'Visa färre' : 'Visa fler'));
};
setGlobal('svs.components.tipsen.couponScore.EventParticipantOutcome', EventParticipantOutcome);

 })(window);